import { render, staticRenderFns } from "./FacebookSignup.vue?vue&type=template&id=10414730&lang=pug&"
import script from "./FacebookSignup.vue?vue&type=script&lang=ts&"
export * from "./FacebookSignup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports